import axios from "../utils/axios";

export function generalSearch(term) {
  return axios.get(`/GeneralSearch/Search/${term}`);
}
